import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './About.css';
import { about } from '../config';

const About = () => {
  const ref = useRef(null);
  const show = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section id="about" className="about" ref={ref}>
      <div className="container">
        <motion.div className="section-label" initial={{ opacity: 0, y: 10 }} animate={show ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5 }}>
          <span>About</span>
        </motion.div>

        <motion.h2 className="section-heading" initial={{ opacity: 0, y: 20 }} animate={show ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: 0.05 }}>
          Background
        </motion.h2>

        {/* Big bio statement */}
        <motion.p
          className="about-statement"
          initial={{ opacity: 0, y: 20 }}
          animate={show ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          {about.bio}
        </motion.p>

        <div className="about-grid">
          {/* Stats */}
          <motion.div
            className="about-stats"
            initial={{ opacity: 0, y: 20 }}
            animate={show ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            {about.stats.map((s, i) => (
              <div key={i} className="stat">
                <span className="stat-num">{s.value}</span>
                <span className="stat-label">{s.label}</span>
              </div>
            ))}
          </motion.div>

          {/* Skills */}
          <motion.div
            className="about-skills"
            initial={{ opacity: 0, y: 20 }}
            animate={show ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.25 }}
          >
            <h3 className="skills-heading">What I work with</h3>
            <div className="skills-grid">
              {about.skills.map((skill, i) => (
                <span key={i} className="skill">{skill}</span>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
